import React from "react";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const ExportExcel = ({ jsonData }) => {
  const flattenTreeForExcel = (node, ultimateParent = null, parent = null, result = []) => {
    if (!ultimateParent) ultimateParent = node;

    if (node.children && node.children.length > 0) {
      node.children.forEach(child => {
        result.push({
          ultimateParentName: ultimateParent.name || "",
          ultimateParentId: ultimateParent.metadata || "",
          parentName: node.name || "",
          parentId: node.metadata || "",
          childName: child.name || "",
          childId: child.metadata || "",
        });

        flattenTreeForExcel(child, ultimateParent, node, result);
      });
    }

    return result;
  };

  const exportToExcel = () => {
    if (!jsonData) {
      alert("No data to export");
      return;
    }

    const flattenedData = flattenTreeForExcel(jsonData);

    const mappedData = flattenedData.map(item => ({
      "Ultimate Parent": item.ultimateParentName,
      "Ultimate Parent Glue ID": item.ultimateParentId,
      "Parent": item.parentName,
      "Parent Glue ID": item.parentId,
      "Children": item.childName,
      "Children Glue ID": item.childId,
    }));

    const worksheet = XLSX.utils.json_to_sheet(mappedData);

    // ✅ Set column widths
    worksheet["!cols"] = [
      { wch: 35 }, // Ultimate Parent
      { wch: 30 }, // Ultimate Parent ID
      { wch: 35 }, // Parent
      { wch: 30 }, // Parent ID
      { wch: 35 }, // Children
      { wch: 30 }, // Children ID
    ];

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Hierarchy');

    const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });

    const fileName = `${jsonData.name || "Ultimate Parent"} Meta Data.xlsx`;
    saveAs(blob, fileName);
  };

  return (
    <div>
      <button onClick={exportToExcel}>Export to Excel</button>
    </div>
  );
};

export default ExportExcel;
